module.exports = __webpack_public_path__ + "static/assets/5adaa261f3eb23082cdb747db369baa2.svg";